/** @format */

import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { useMessageContext } from '../../../context/Message.context';
import LiveEdithTextHighLighter from '../../../liveEditHighlighterstyles/liveEdithTextHighLighter.component';
import useContactUs from '../../../utils/apis/Contactus.api';
import GetTemplateData from '../../../utils/apis/GetTemplateData.api';
import NavbarT3 from '../Components/navbar/navbar.t3';
import FooterT3 from '../footer/footer.t3';
import { ContactUsContainer, Container } from './contact_us.style';
import { Helmet } from 'react-helmet-async';
import Cookies from "js-cookie";
import axios from 'axios';
import { HelmetSEO } from '../../../utils/HelmetSEO/HelmetSEO.utilcomponent';

interface Seolisting {
  _id: string;
  title: string;
  keywords: string;
  description: string;
  url: string;
}

export default function ContactUs({ templateData, templateId }) {
  const { SubmitFormSellerLead, handleFormData, formData } = useContactUs();
  const { setTheme } = useMessageContext();
  const [data, setData] = useState(null);
  const [profile, setProfile] = useState(null)
  const [Seo, setSeo] = useState<Seolisting[]>([]);
  const [seoHomeData, setSeoHomeData] = useState<Seolisting | null>(null);
  const { preview } = useParams();
  const token = Cookies.get("token");

  //local Data
  useEffect(() => {
    const getData = async () => {
      if (!templateData) {
        const data = await GetTemplateData(preview, 3, 3);
        if (data) {
          setData(data);
          setTheme({
            primary_color: data.styles[0].css.primary,
            secondary_color: data.styles[0].css.secondary,
            borderRadius: '16px',
            warning_message: {
              fontFamily: 'Oswald',
              fontSize: '20px',
              fontWeight: '400',
              lineHeight: '23.4px',
            },
            warning_text: {
              fontFamily: 'Roboto',
              fontSize: '18px',
              fontWeight: '400',
              lineHeight: '22.32px',
              textAlign: 'center',
            },
            button: {
              fontFamily: 'Roboto',
              fontSize: '18px',
              fontWeight: '400',
              lineHeight: '23.4px',
            },
          });
        }
      } else {
        setData(templateData);
      }
    };
    getData();
  }, [templateData]);

  useEffect(() => {
    const fetchProfile = async (): Promise<void> => {
      const agentUrl = window.location.href.split("/")[2];
      let config = {
        headers: {},
        params: {},
      };
      if (token) {
        config.headers["x-access-token"] = token;
      } else {
        config.params["domain"] = agentUrl;
      }
      try {
        const profileData = await axios.get("/api/get-agent-profile", config);
        setProfile(profileData.data.data);

      } catch (e) {
        throw new Error(e);
      }
    };
    fetchProfile();
  }, []);


  useEffect(() => {
    const FetchSeo = async () => {
      const token = Cookies.get("token");
      const agentUrl = window.location.href.split("/")[2];
      let config = {
        headers: {},
        params: {},
      };

      if (token) {
        config.headers["x-access-token"] = token;
      } else {
        config.params["domain"] = agentUrl;
      }

      try {
        const fetchData = await axios.get("/api/get-all-seo-entries", config);
        const fetchedData = fetchData.data.data;
        const homeSeoEntry = fetchedData.find((entry) => entry.url.includes('contact'));
        setSeoHomeData(homeSeoEntry || null);
      } catch (e) {
        console.error("Error fetching seo listings:", e);
      }
    };

    FetchSeo();
  }, []);
  const defaultDescription = `Detailed REALTOR® profile for ${profile?.name || 'Agent'} ,Real Estate Broker Contact ${profile?.name || 'Agent'} , real estate agent at ROYAL STAR REALTY INC. in BRAMPTON, Ontario.`;
  const defaultKeywords = `Contact REALTOR® ${profile?.name || 'Agent'},Schedule a Consultation with ${profile?.name || 'Agent'},real estate listings, homes for sale, homes for rent, property listings,Contact a REALTOR® for Homes for Sale`;




  if (!data)
    return (
      <div
        id="loadingScreen"
        className="loading-screen">
        <div className="loader"></div>
      </div>
    );
  const theme = {
    colors: {
      primary: data.styles[0].css.primary,
      text: data.styles[0]?.css?.secondary,
      //common
      TextGrey: '#6E6E73',
      white: '#FDFDFE',
      InactiveGrey: '#b2b2b2',
      text2: '#000000',
      background: '#f8f9fa',
    },
  };
  return (
    <>
      <HelmetSEO seoHomeData={seoHomeData} profile={profile} defaultDescription={defaultDescription} defaultKeywords={defaultKeywords} />
      <ThemeProvider theme={theme}>
        <NavbarT3 />
        <Container id="sec1">
          <ContactUsContainer>
            <svg
              width="100"
              height="85"
              viewBox="0 0 100 85"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="dots">
              <rect
                x="100"
                width="8"
                height="8"
                rx="4"
                transform="rotate(90 100 0)"
                fill="#2C3647"
              />
              <rect
                x="100"
                y="23"
                width="8"
                height="8"
                rx="4"
                transform="rotate(90 100 23)"
                fill="#2C3647"
              />
              <rect
                x="100"
                y="46"
                width="8"
                height="8"
                rx="4"
                transform="rotate(90 100 46)"
                fill="#2C3647"
              />
              <rect
                x="100"
                y="69"
                width="8"
                height="8"
                rx="4"
                transform="rotate(90 100 69)"
                fill="#2C3647"
              />
              <rect
                x="77"
                width="8"
                height="8"
                rx="4"
                transform="rotate(90 77 0)"
                fill="#2C3647"
              />
              <rect
                x="77"
                y="23"
                width="8"
                height="8"
                rx="4"
                transform="rotate(90 77 23)"
                fill="#2C3647"
              />
              <rect
                x="77"
                y="46"
                width="8"
                height="8"
                rx="4"
                transform="rotate(90 77 46)"
                fill="#2C3647"
              />
              <rect
                x="77"
                y="69"
                width="8"
                height="8"
                rx="4"
                transform="rotate(90 77 69)"
                fill="#2C3647"
              />
              <rect
                x="54"
                width="8"
                height="8"
                rx="4"
                transform="rotate(90 54 0)"
                fill="#2C3647"
              />
              <rect
                x="54"
                y="23"
                width="8"
                height="8"
                rx="4"
                transform="rotate(90 54 23)"
                fill="#2C3647"
              />
              <rect
                x="54"
                y="46"
                width="8"
                height="8"
                rx="4"
                transform="rotate(90 54 46)"
                fill="#2C3647"
              />
              <rect
                x="54"
                y="69"
                width="8"
                height="8"
                rx="4"
                transform="rotate(90 54 69)"
                fill="#2C3647"
              />
              <rect
                x="31"
                width="8"
                height="8"
                rx="4"
                transform="rotate(90 31 0)"
                fill="#2C3647"
              />
              <rect
                x="31"
                y="23"
                width="8"
                height="8"
                rx="4"
                transform="rotate(90 31 23)"
                fill="#2C3647"
              />
              <rect
                x="31"
                y="46"
                width="8"
                height="8"
                rx="4"
                transform="rotate(90 31 46)"
                fill="#2C3647"
              />
              <rect
                x="31"
                y="69"
                width="8"
                height="8"
                rx="4"
                transform="rotate(90 31 69)"
                fill="#2C3647"
              />
              <rect
                x="8"
                width="8"
                height="8"
                rx="4"
                transform="rotate(90 8 0)"
                fill="#2C3647"
              />
              <rect
                x="8"
                y="23"
                width="8"
                height="8"
                rx="4"
                transform="rotate(90 8 23)"
                fill="#2C3647"
              />
              <rect
                x="8"
                y="46"
                width="8"
                height="8"
                rx="4"
                transform="rotate(90 8 46)"
                fill="#2C3647"
              />
              <rect
                x="8"
                y="69"
                width="8"
                height="8"
                rx="4"
                transform="rotate(90 8 69)"
                fill="#2C3647"
              />
            </svg>
            <svg
              width="442"
              height="442"
              viewBox="0 0 442 442"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="circle_svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M221 0C98.9451 0 0 98.9451 0 221C0 343.055 98.9451 442 221 442C343.055 442 442 343.055 442 221C442 98.9451 343.055 0 221 0ZM220.998 63.1431C133.816 63.1431 63.1406 133.818 63.1406 221C63.1406 308.182 133.816 378.857 220.998 378.857C308.18 378.857 378.855 308.182 378.855 221C378.855 133.818 308.18 63.1431 220.998 63.1431Z"
                fill="#2C3647"
              />
            </svg>
            <div className="lef_contact_us_section">
              <div className="image_container_contact_us">
                <img
                  src={`/public/${data.sec1.image}`}
                  alt="ImageNotFound"
                  className="contact_us_image"
                />
              </div>
            </div>
            <div className="right_contact_us_section">
              <div className="header_container">
                <p className="header">
                  <LiveEdithTextHighLighter
                    section="sec1"
                    type="text">
                    {data.sec1.text}
                  </LiveEdithTextHighLighter>
                </p>
                <p className="sub_header">
                  <LiveEdithTextHighLighter
                    section="sec1"
                    type="description">
                    <div
                      dangerouslySetInnerHTML={{ __html: data.sec1.description }}
                      className="quote"></div>
                  </LiveEdithTextHighLighter>
                </p>
              </div>
              <div className="agent_info_container">
                <p className="number">
                  <div className="svg_wrapper">
                    <svg
                      width="19"
                      height="19"
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M17.0351 12.8962L14.3892 12.5941C14.0781 12.5575 13.7628 12.592 13.4669 12.6948C13.171 12.7977 12.9023 12.9662 12.6809 13.1878L10.7642 15.1045C7.80715 13.6006 5.4036 11.197 3.89966 8.23991L5.82674 6.31283C6.27466 5.86491 6.49341 5.23991 6.42049 4.60449L6.11841 1.97949C6.05935 1.47134 5.81549 1.00266 5.43324 0.662668C5.05099 0.32268 4.55706 0.135136 4.04549 0.135744H2.24341C1.06633 0.135744 0.0871599 1.11491 0.160077 2.29199C0.71216 11.1878 7.82674 18.292 16.7122 18.8441C17.8892 18.917 18.8684 17.9378 18.8684 16.7607V14.9587C18.8788 13.9066 18.0872 13.0212 17.0351 12.8962Z"
                        fill="#2C3647"
                      />
                    </svg>
                  </div>
                  <LiveEdithTextHighLighter
                    section="sec1"
                    type="phone">
                    {data.sec1.phone}
                  </LiveEdithTextHighLighter>
                </p>
                <p className="email">
                  <div className="svg_wrapper">
                    <svg
                      width="21"
                      height="17"
                      viewBox="0 0 21 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M18.8359 0.166016H2.16927C1.02344 0.166016 0.0963542 1.10352 0.0963542 2.24935L0.0859375 14.7493C0.0859375 15.8952 1.02344 16.8327 2.16927 16.8327H18.8359C19.9818 16.8327 20.9193 15.8952 20.9193 14.7493V2.24935C20.9193 1.10352 19.9818 0.166016 18.8359 0.166016ZM18.4193 4.5931L11.0547 9.19727C10.7214 9.4056 10.2839 9.4056 9.95052 9.19727L2.58594 4.5931C2.48149 4.53446 2.39002 4.45525 2.31707 4.36024C2.24412 4.26523 2.19121 4.15641 2.16154 4.04036C2.13186 3.92431 2.12604 3.80345 2.14443 3.68509C2.16282 3.56672 2.20504 3.45332 2.26852 3.35175C2.33201 3.25017 2.41544 3.16253 2.51378 3.09414C2.61211 3.02574 2.7233 2.97801 2.84062 2.95383C2.95794 2.92965 3.07894 2.92952 3.19631 2.95346C3.31367 2.9774 3.42496 3.0249 3.52344 3.0931L10.5026 7.45768L17.4818 3.0931C17.5802 3.0249 17.6915 2.9774 17.8089 2.95346C17.9263 2.92952 18.0473 2.92965 18.1646 2.95383C18.2819 2.97801 18.3931 3.02574 18.4914 3.09414C18.5898 3.16253 18.6732 3.25017 18.7367 3.35175C18.8002 3.45332 18.8424 3.56672 18.8608 3.68509C18.8792 3.80345 18.8733 3.92431 18.8437 4.04036C18.814 4.15641 18.7611 4.26523 18.6881 4.36024C18.6152 4.45525 18.5237 4.53446 18.4193 4.5931Z"
                        fill="#2C3647"
                      />
                    </svg>
                  </div>
                  <LiveEdithTextHighLighter
                    section="sec1"
                    type="email">
                    {data.sec1.email}
                  </LiveEdithTextHighLighter>
                </p>
                <p className="address">
                  <div className="svg_wrapper">
                    <svg
                      width="17"
                      height="21"
                      viewBox="0 0 17 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8.4974 0.0839844C4.1224 0.0839844 0.164062 3.43815 0.164062 8.62565C0.164062 11.9382 2.71615 15.834 7.8099 20.3236C8.20573 20.6673 8.79948 20.6673 9.19531 20.3236C14.2786 15.834 16.8307 11.9382 16.8307 8.62565C16.8307 3.43815 12.8724 0.0839844 8.4974 0.0839844ZM8.4974 10.5007C7.35156 10.5007 6.41406 9.56315 6.41406 8.41732C6.41406 7.27148 7.35156 6.33398 8.4974 6.33398C9.64323 6.33398 10.5807 7.27148 10.5807 8.41732C10.5807 9.56315 9.64323 10.5007 8.4974 10.5007Z"
                        fill="#2C3647"
                      />
                    </svg>
                  </div>
                  <LiveEdithTextHighLighter
                    section="sec1"
                    type="address">
                    <div
                      dangerouslySetInnerHTML={{ __html: data.sec1.address }}
                      className="address_text"></div>
                  </LiveEdithTextHighLighter>
                </p>
              </div>
              <form
                className="contact_us_form"
                onSubmit={(e) => SubmitFormSellerLead(e)}>
                <div className="name_email">
                  <div className="name">
                    <label>Your Name</label>
                    <div className="input_box_container">
                      <div className="svg_wrapper">
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M10.9974 10.9993C9.56081 10.9993 8.18306 10.4287 7.16723 9.41284C6.15141 8.39702 5.58073 7.01927 5.58073 5.58268C5.58073 4.14609 6.15141 2.76834 7.16723 1.75252C8.18306 0.736698 9.56081 0.166016 10.9974 0.166016C12.434 0.166016 13.8117 0.736698 14.8276 1.75252C15.8434 2.76834 16.4141 4.14609 16.4141 5.58268C16.4141 7.01927 15.8434 8.39702 14.8276 9.41284C13.8117 10.4287 12.434 10.9993 10.9974 10.9993ZM10.9974 15.0618C15.3118 15.0618 19.1833 15.8351 21.8307 19.2097V21.8327H0.164062V19.2097C2.81146 15.8337 6.68302 15.0618 10.9974 15.0618Z"
                            fill="#2C3647"
                          />
                        </svg>
                      </div>
                      <input
                        type="text"
                        placeholder="Name"
                        className="input_box"
                        value={formData.name}
                        onChange={(e) => handleFormData('name', e)}
                        required
                      />
                    </div>
                  </div>
                  <div className="email">
                    <label>Mail</label>
                    <div className="input_box_container">
                      <div className="svg_wrapper">
                        <svg
                          width="23"
                          height="18"
                          viewBox="0 0 23 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M20.1641 0.333984H2.83073C1.63906 0.333984 0.664062 1.30898 0.664062 2.50065V15.5007C0.664062 16.6923 1.63906 17.6673 2.83073 17.6673H20.1641C21.3557 17.6673 22.3307 16.6923 22.3307 15.5007V2.50065C22.3307 1.30898 21.3557 0.333984 20.1641 0.333984ZM19.7307 4.93815L12.6457 9.36899C11.9416 9.81315 11.0532 9.81315 10.3491 9.36899L3.26406 4.93815C3.15543 4.87717 3.06031 4.79478 2.98444 4.69598C2.90858 4.59717 2.85355 4.48399 2.82269 4.3633C2.79182 4.24261 2.78577 4.11691 2.8049 3.99382C2.82402 3.87072 2.86793 3.75278 2.93395 3.64714C2.99997 3.54151 3.08675 3.45036 3.18902 3.37923C3.29128 3.3081 3.40692 3.25846 3.52893 3.23331C3.65094 3.20816 3.77679 3.20803 3.89885 3.23293C4.02091 3.25782 4.13665 3.30723 4.23906 3.37815L11.4974 7.91732L18.7557 3.37815C18.8581 3.30723 18.9739 3.25782 19.0959 3.23293C19.218 3.20803 19.3438 3.20816 19.4659 3.23331C19.5879 3.25846 19.7035 3.3081 19.8058 3.37923C19.908 3.45036 19.9948 3.54151 20.0608 3.64714C20.1269 3.75278 20.1708 3.87072 20.1899 3.99382C20.209 4.11691 20.203 4.24261 20.1721 4.3633C20.1412 4.48399 20.0862 4.59717 20.0103 4.69598C19.9345 4.79478 19.8394 4.87717 19.7307 4.93815Z"
                            fill="#2C3647"
                          />
                        </svg>
                      </div>
                      <input
                        type="email"
                        placeholder="Email"
                        className="input_box"
                        value={formData.email}
                        onChange={(e) => handleFormData('email', e)}
                        required
                      />
                    </div>
                  </div>
                  <div className="email">
                    <label>Phone</label>
                    <div className="input_box_container">
                      <div className="svg_wrapper">
                        <svg
                          width="26"
                          height="26"
                          viewBox="0 0 26 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M20.8352 16.5326L18.0836 16.2184C17.76 16.1804 17.4321 16.2162 17.1243 16.3232C16.8166 16.4301 16.5371 16.6054 16.3069 16.8359L14.3136 18.8292C11.2382 17.2651 8.73849 14.7654 7.1744 11.6901L9.17856 9.68589C9.6444 9.22005 9.8719 8.57005 9.79606 7.90922L9.4819 5.17922C9.42048 4.65074 9.16686 4.16331 8.76932 3.80972C8.37178 3.45613 7.8581 3.26109 7.32606 3.26172H5.4519C4.22773 3.26172 3.2094 4.28005 3.28523 5.50422C3.8594 14.7559 11.2586 22.1442 20.4994 22.7184C21.7236 22.7942 22.7419 21.7759 22.7419 20.5517V18.6776C22.7527 17.5834 21.9294 16.6626 20.8352 16.5326Z"
                            fill="#432B1E"
                          />
                        </svg>
                      </div>
                      <input
                        type="number"
                        placeholder="Phone Number"
                        className="input_box"
                        value={formData.phone}
                        onChange={(e) => handleFormData('phone', e)}
                        required
                      />
                    </div>
                  </div>
                  <div className="email">
                    <label>Address</label>
                    <div className="input_box_container">
                      <div className="svg_wrapper">
                        <svg
                          width="26"
                          height="26"
                          viewBox="0 0 26 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M12.9948 2.16797C8.44479 2.16797 4.32812 5.6563 4.32812 11.0513C4.32812 14.4963 6.98229 18.548 12.2798 23.2171C12.6915 23.5746 13.309 23.5746 13.7206 23.2171C19.0073 18.548 21.6615 14.4963 21.6615 11.0513C21.6615 5.6563 17.5448 2.16797 12.9948 2.16797ZM12.9948 13.0013C11.8031 13.0013 10.8281 12.0263 10.8281 10.8346C10.8281 9.64297 11.8031 8.66797 12.9948 8.66797C14.1865 8.66797 15.1615 9.64297 15.1615 10.8346C15.1615 12.0263 14.1865 13.0013 12.9948 13.0013Z"
                            fill="#432B1E"
                          />
                        </svg>
                      </div>
                      <input
                        type=""
                        placeholder="address"
                        className="input_box"
                        value={formData.address}
                        onChange={(e) => handleFormData('address', e)}
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="message">
                  <label>Message</label>
                  <textarea
                    placeholder="Message"
                    className="text_box"
                    value={formData.message}
                    onChange={(e) => handleFormData('message', e)}
                    required
                  />
                </div>
                <div className="link_send_message">
                  <div className="Link_container">
                    <a
                      href={data.sec1.socialmedialinks[0].link}
                      target="_blank"
                      rel="noreferrer">
                      <div className="svg_wrapper">
                        <svg
                          width="13"
                          height="20"
                          viewBox="0 0 13 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M12.1404 7.5H7.5V6.128C7.5 4.80514 7.5838 4.51556 7.73926 4.22514C7.85455 4.00879 8.00961 3.85411 8.22596 3.73882C8.51638 3.58336 8.80514 3.5 10.128 3.5H12V0.761538L11.6236 0.665516C11.1814 0.55272 10.6802 0.5 10.128 0.5C8.30489 0.5 7.56486 0.690428 6.81128 1.09252C6.07909 1.48031 5.48029 2.07912 5.09251 2.8113C4.69042 3.56488 4.5 4.3049 4.5 6.128V7.5H0.5V10.5H4.5V19.5H7.5V10.5H11.3904L12.1404 7.5Z"
                            fill="#2C3647"
                          />
                        </svg>
                      </div>
                    </a>
                    <a
                      href={data.sec1.socialmedialinks[1].link}
                      target="_blank"
                      rel="noreferrer">
                      <div className="svg_wrapper">
                        <svg
                          width="24"
                          height="22"
                          viewBox="0 0 24 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M18.901 0.152344H22.581L14.541 9.34234L24 21.8453H16.594L10.794 14.2613L4.156 21.8453H0.474L9.074 12.0153L0 0.153344H7.594L12.837 7.08534L18.901 0.152344ZM17.61 19.6433H19.649L6.486 2.23934H4.298L17.61 19.6433Z"
                            fill="#272021"
                          />
                        </svg>
                      </div>
                    </a>
                    <a
                      href={data.sec1.socialmedialinks[2].link}
                      target="_blank"
                      rel="noreferrer">
                      <div className="svg_wrapper">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9ZM12 7C13.3261 7 14.5979 7.52678 15.5355 8.46447C16.4732 9.40215 17 10.6739 17 12C17 13.3261 16.4732 14.5979 15.5355 15.5355C14.5979 16.4732 13.3261 17 12 17C10.6739 17 9.40215 16.4732 8.46447 15.5355C7.52678 14.5979 7 13.3261 7 12C7 10.6739 7.52678 9.40215 8.46447 8.46447C9.40215 7.52678 10.6739 7 12 7ZM18.5 6.75C18.5 7.08152 18.3683 7.39946 18.1339 7.63388C17.8995 7.8683 17.5815 8 17.25 8C16.9185 8 16.6005 7.8683 16.3661 7.63388C16.1317 7.39946 16 7.08152 16 6.75C16 6.41848 16.1317 6.10054 16.3661 5.86612C16.6005 5.6317 16.9185 5.5 17.25 5.5C17.5815 5.5 17.8995 5.6317 18.1339 5.86612C18.3683 6.10054 18.5 6.41848 18.5 6.75ZM12 4C9.526 4 9.122 4.007 7.971 4.058C7.187 4.095 6.661 4.2 6.173 4.39C5.739 4.558 5.426 4.759 5.093 5.093C4.78001 5.3954 4.53935 5.76458 4.389 6.173C4.199 6.663 4.094 7.188 4.058 7.971C4.006 9.075 4 9.461 4 12C4 14.474 4.007 14.878 4.058 16.029C4.095 16.812 4.2 17.339 4.389 17.826C4.559 18.261 4.759 18.574 5.091 18.906C5.428 19.242 5.741 19.443 6.171 19.609C6.665 19.8 7.191 19.906 7.971 19.942C9.075 19.994 9.461 20 12 20C14.474 20 14.878 19.993 16.029 19.942C16.811 19.905 17.338 19.8 17.826 19.611C18.259 19.442 18.574 19.241 18.906 18.909C19.243 18.572 19.444 18.259 19.61 17.829C19.8 17.336 19.906 16.809 19.942 16.029C19.994 14.925 20 14.539 20 12C20 9.526 19.993 9.122 19.942 7.971C19.905 7.189 19.8 6.661 19.61 6.173C19.4593 5.765 19.2191 5.39596 18.907 5.093C18.6047 4.77985 18.2355 4.53917 17.827 4.389C17.337 4.199 16.811 4.094 16.029 4.058C14.925 4.006 14.539 4 12 4ZM12 2C14.717 2 15.056 2.01 16.122 2.06C17.187 2.11 17.912 2.277 18.55 2.525C19.21 2.779 19.766 3.123 20.322 3.678C20.8305 4.1779 21.224 4.78259 21.475 5.45C21.722 6.087 21.89 6.813 21.94 7.878C21.987 8.944 22 9.283 22 12C22 14.717 21.99 15.056 21.94 16.122C21.89 17.187 21.722 17.912 21.475 18.55C21.2247 19.2178 20.8311 19.8226 20.322 20.322C19.822 20.8303 19.2173 21.2238 18.55 21.475C17.913 21.722 17.187 21.89 16.122 21.94C15.056 21.987 14.717 22 12 22C9.283 22 8.944 21.99 7.878 21.94C6.813 21.89 6.088 21.722 5.45 21.475C4.78233 21.2245 4.17753 20.8309 3.678 20.322C3.16941 19.8222 2.77593 19.2175 2.525 18.55C2.277 17.913 2.11 17.187 2.06 16.122C2.013 15.056 2 14.717 2 12C2 9.283 2.01 8.944 2.06 7.878C2.11 6.812 2.277 6.088 2.525 5.45C2.77524 4.78218 3.1688 4.17732 3.678 3.678C4.17767 3.16923 4.78243 2.77573 5.45 2.525C6.088 2.277 6.812 2.11 7.878 2.06C8.944 2.013 9.283 2 12 2Z"
                            fill="#2C3647"
                          />
                        </svg>
                      </div>
                    </a>
                  </div>
                  <button
                    type="submit"
                    className="submit_button">
                    Send Message
                  </button>
                </div>
              </form>
            </div>
          </ContactUsContainer>
        </Container>
        {/* {messagebox && (
        <ErrorBox>
          <div className="wrap">
            <div
              className="icon_wrapper"
              onClick={() => setMessageBox(false)}>
              <IoMdClose size={25} />
            </div>
            <p>{message}</p>
          </div>
        </ErrorBox>
      )} */}
        <FooterT3 data={data} />
      </ThemeProvider>
    </>
  );
}
